import React from "react";
import { PaintRoller, Square, DoorOpen, Building2, Users, Hammer, ArrowRight } from "lucide-react";
import { services } from "../mock";

const iconMap = { PaintRoller, Square, DoorOpen, Building2, Users, Hammer };

const Services = () => {
  return (
    <section id="diensten" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-4 border border-yellow-200">
            Onze diensten
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 text-balance">
            Wat wij voor u spuiten
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            Van een enkele kamer tot een compleet bedrijfspand – wij verzorgen het
            volledige latex spuitwerk, vakkundig en in één keer goed.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || PaintRoller;
            return (
              <div
                key={s.title}
                className="group relative rounded-2xl border border-slate-200 bg-white p-6 hover-lift"
              >
                <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center mb-5 group-hover:rotate-6 transition-transform">
                  <Icon className="w-6 h-6 text-slate-900" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.description}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity">
                  Meer info <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
